// extracted by mini-css-extract-plugin
export default {"tierBox":"Disclaimer_tierBox__u90nW","checkboxContainer":"Disclaimer_checkboxContainer__Qwpek","tierLabel":"Disclaimer_tierLabel__i8OLi"};